import React, { useEffect, useRef, useState } from 'react';
import Header from '../../directives/header';
import Footer from '../../directives/footer';
import Sidebar from '../../directives/sidebar';
import toast, { Toaster } from 'react-hot-toast';
import JoditEditor from 'jodit-react';
import { getAllCms, updateCms } from "../../Action/action";

const VestingSchedule = () => {
  const editor = useRef(null);

  const [vestingSchedule, setVestingScheduleId] = useState(null);
  const [vestingScheduleContent, setVestingScheduleContent] = useState('');

  useEffect(() => {
    getCmsDetail();
  }, []);

  const getCmsDetail = async () => {
    try {
      const res = await getAllCms();
      if (res.status) {
        setVestingScheduleId(res.data._id);
        setVestingScheduleContent(res.data.vestingSchedule);
      }
    } catch (err) {
      toast.error("Failed to fetch Vesting Schedule");
    }
  };

  const handleUpdate = async () => {
    if (!vestingSchedule) {
      toast.error("Vesting Schedule ID missing");
      return;
    }

    try {
      const res = await updateCms({
        _id: vestingSchedule,
        vestingSchedule: vestingScheduleContent,
      });

      if (res.status) {
        toast.success('Vesting Schedule updated successfully!');
        getCmsDetail(); // refresh data
      }
    } catch (error) {
      toast.error(error.message || "Failed to update Vesting Schedule");
    }
  };

  return (
    <div className="wrapper h-auto">
      <Header />
      <Toaster />
      <Sidebar />

      <div className="content-wrapper">
        <div className="container-full">
          <section className="content">
            <div className="row">
              <div className="col-lg-12 col-12 p-4">
                <div className="box">
                  <div className="box-header with-border">
                    <h3 className="box-title" style={{ fontWeight: 600 }}>
                      Vesting Schedule
                    </h3>
                  </div>

                  <div className="row mt-20 mb-50">
                    <div className="col-md-12">
                      <div className="form-group row mb-3 px-15">
                        <label className="col-form-label">
                          Vesting Schedule Content
                        </label>

                        <JoditEditor
                          ref={editor}
                          value={vestingScheduleContent}
                          tabIndex={1}
                          onBlur={(newContent) =>
                            setVestingScheduleContent(newContent)
                          }
                        />
                      </div>

                      <div className="text-start px-15">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleUpdate}
                        >
                          Update
                        </button>
                      </div>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default VestingSchedule;
